import Model from '@/models/Model';
import TicketStatus from '@/models/TicketStatus';
import api from '@/services/Api';

export default class Ticket extends Model {
    get route () {
        return 'tickets';
    }

    static get className () {
        return 'Ticket';
    }

    merge (ids) {
        return api.post(`${this.route}/merge`, {
            ids,
        });
    }

    close () {
        return this.update({
            status_id: TicketStatus.getIdByType('closed'),
        });
    }

    clone () {
        return api.post(`${this.route}/${this[this.primaryKey]}/clone`);
    }

    restore (confirmMe = 'Echt herstellen?') {
        if (!confirmMe || confirm(confirmMe)) {
            return api.post(`${this.route}/${this[this.primaryKey]}/restore`);
        }
    }
}
